<!-- 三级详情页面 -->
<template>
  <div class="jr-view">
    <van-image v-for="(item, index) in list" :key="index" width="100%" fit="contain" :src="item" :show-loading="false"></van-image>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import jrConfig from '../../config/jinrong.js'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      list: [],
      showStayTuned: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    if (this.$route.params.details) {
      this.list = this.$route.params.details;
    }
    // type : 1:银发奖 2:敬请期待
    if (this.$route.query.type == 1) {
      this.list = jrConfig.yinfajiang;
      document.title = "银发奖";
    }
    if (this.$route.query.type == 2) {
      this.list = jrConfig.staytuned;
      document.title = "敬请期待";
    }
    if (this.$route.query.type == 3 && this.$route.query.src) {
      if (this.$route.query.title) {
        document.title = this.$route.query.title
      }
      setViewPort(1.0, 10.0, 1.0)
      let imgs = this.$route.query.src + '?t=' + Math.random()
      imgs = imgs.split("|")
      this.list = [...imgs];
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    if (this.$route.params.title) {
      document.title = this.$route.params.title;
    }
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.jr-view {
  max-width: 750px;
  margin: 0 auto;
}
.van-image {
  display: inline;
}
</style>
